import type { FaireProductEntity } from "../../entity_types/product";

export const p_jzck6fc585: FaireProductEntity = {
  token: "p_jzck6fc585",
  type: "product",
  name: "Basic Short Sleeve Baby Bodysuit Onesie  (Organic Cotton)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/9e403477624eb1dcc5a48486e88d8d1a68c1593d91dc090fc1c1e5d6a5f84744.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fefe0977cb6e038214a07105782980deca00f201689219c9140fca9386b4e1f1.png",
    "https://cdn.faire.com/fastly/fcf4f0ea0a5cb6a7f0d2e467f42ca06c6a534a4868dfd4a79df084979d02ecb5.png",
  ],
  priceDollars: 8,
  description:
    "Organic short sleeve basic baby onesie bodysuit in soft white color.\n• 3 snap opening in the back & 2 snap opening in the crotch for easy changes.\n• Ultra soft, lightweight, breathable, cozy, and comfy.\n• Chemical free & non-toxic formulation, eco-friendly & sustainable.\n• Machine wash and dry, durable and long lasting.\n• Ethically produced in India from small farmer sourced cotton.\n• 95% organic cotton jersey / 5% lycra stretch formulation for extra comfort.\n\nViverano, an American brand, was founded in 2013 with the simple idea of producing eco-friendly, pure and organic baby clothes. Viverano baby clothing is known for its soft hand feel and high quality. Pamper your precious babies with our non-toxic, lightweight, all-season, natural baby outfits.\n\nExperience 'Organic Comfort' by Viverano, a family-owned small business.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:34.101Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
